<template>
  <div class="audio_msg_box" @click="$downapppop.open">
    <dl class="audio_msg_content">
      <dt>
        <img :src="require('@/assets/images/icon_triangular_play_btn@2x.png')" alt />
      </dt>
      <dd>
        <span>00:00</span>
        <div></div>
        <span>{{strToTimeStr(audioLen)}}</span>
      </dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: "imageViewpoint",
  props: {
    audioLen: Number
  },
  created() {},
  methods: {
    strToTimeStr(str) {
      let minuteStr = Math.floor(+str / 60);
      let secondStr = +str % 60;
      minuteStr = minuteStr < 10 ? "0" + minuteStr : minuteStr;
      secondStr = secondStr < 10 ? "0" + secondStr : secondStr;
      return minuteStr + ":" + secondStr;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
//语音消息
.audio_msg_box {
  padding: 12px 14px 0;
  .audio_msg_content {
    // width: 100%;
    height: 62px;
    background: #f5f6f7;
    padding-left: 10px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    > dt {
      width: 40px;
      height: 40px;
      overflow: hidden;
      flex-shrink: 0;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fe484a;
      > img {
        width: 16px;
        height: 16px;
      }
    }
    > dd {
      height: 100%;
      // padding: 0 15px;
      display: flex;
      justify-content: space-between;
      flex: 1;
      align-items: center;

      > div {
        height: 2px;
        border-radius: 1px;
        background: #e8e8e8;
        flex: 1;
      }
      > span {
        font-size: 11px;
        line-height: 15px;
        color: #636363;
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
      }
    }
  }
}
</style>